/// <reference types="@types/googlemaps" />
import { Loader } from "@googlemaps/js-api-loader";
import { ENVS } from "@app/domains/shared/config";
import invoke from "lodash/invoke";

const googleMapsLoader = new Loader({
  apiKey: ENVS.GOOGLE_MAPS_API_KEY,
  libraries: ["places", "drawing", "geometry"],
});

export async function getPlacePredictions(
  query = "",
  callbacks = {},
  position = { lat: 1, lng: 1 },
  radius = 1000
) {
  if (!("google" in global)) {
    await googleMapsLoader.importLibrary("maps");
  }

  if (google?.maps?.places) {
    //@ts-ignore
    const autocomplete = google.maps.places.AutocompleteSuggestion;

    if (!autocomplete) {
      console.log("Autocomplete API was not found");
      return;
    }
    if (query !== "" && query.replace(" ", "").length) {
      invoke(callbacks, "onStartCallback", query);

      const { suggestions } = await autocomplete.fetchAutocompleteSuggestions({
          input: query,
          includedRegionCodes: ["BR"],
          locationBias: position ? { center: position, radius} : undefined,
          origin: position ? new google.maps.LatLng(position) : undefined,
        });
      const suggestionsFormatted = suggestions.map(e => ({description: e.placePrediction.text.text}));
      
      invoke(callbacks, "onSuccessCallback", suggestionsFormatted);
      return;
    }
  }
  invoke(callbacks, "onSuccessCallback", []);
  return;
}
